<script lang="ts">
  export let color = 'white';
</script>

<svg
  style="opacity: 0.6;"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.33332 1.33398L14.6656 14.6662M1.33203 14.6673L14.6643 1.33508"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
